import React from 'react';
import { TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';
import { version as RNVersion } from 'react-native/package.json';

function VFTouchableInScroll({ onPress, children, ...props }) {
  const handlePressIn = event => {
    if (event.nativeEvent.touches.length === 0) {
      onPress();
    }
  };

  // Depend on the onPress instead of the onPressIn behavior starting from version 62 till we find a more concrete solution
  const onPressProp = RNVersion?.split('.')[1] > 61 ? { onPress } : { onPressIn: handlePressIn };

  return (
    <TouchableWithoutFeedback delayPressIn={150} onPress={onPress} {...props}>
      {children}
    </TouchableWithoutFeedback>
  );
}

VFTouchableInScroll.propTypes = {
  children: PropTypes.node,
  onPress: PropTypes.func,
};

export default VFTouchableInScroll;
